import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  fetchTenantProfile,
  updateTenantProfile,
  selectTenantUser,
  selectTenantRole,
  selectTenantProfileLoading,
  selectTenantProfileError,
  selectTenantProfileUpdating,
  selectTenantProfileUpdateError,
  selectTenantProfileUpdateSuccess,
} from "../../../../../store/tenantProfile/tenantProfileSlice";

const ProfileSettings = () => {
  const dispatch = useDispatch();

  /*
        |--------------------------------------------------------------------------
        | REDUX DATA
        |--------------------------------------------------------------------------
        */

  const user = useSelector(selectTenantUser);

  const role = useSelector(selectTenantRole);

  const loading = useSelector(selectTenantProfileLoading);

  const error = useSelector(selectTenantProfileError);

  const updating = useSelector(selectTenantProfileUpdating);

  const updateError = useSelector(selectTenantProfileUpdateError);

  const updateSuccess = useSelector(selectTenantProfileUpdateSuccess);
  /*
        |--------------------------------------------------------------------------
        | FORM
        |--------------------------------------------------------------------------
        */

  const [form, setForm] = useState({
    name: "",

    mobile: "",

    email: "",
  });

  /*
        |--------------------------------------------------------------------------
        | LOAD PROFILE
        |--------------------------------------------------------------------------
        */

  useEffect(() => {
    dispatch(fetchTenantProfile());
  }, [dispatch]);

  /*
        |--------------------------------------------------------------------------
        | SYNC USER INTO FORM
        |--------------------------------------------------------------------------
        */

  useEffect(() => {
    if (!user) {
      return;
    }

    setForm({
      name: user?.name || "",

      mobile: user?.mobile || "",

      email: user?.email || "",
    });
  }, [user]);

  /*
        |--------------------------------------------------------------------------
        | CHANGE
        |--------------------------------------------------------------------------
        */

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,

      [name]: value,
    }));
  };

  /*
        |--------------------------------------------------------------------------
        | SUBMIT
        |--------------------------------------------------------------------------
        |
        | We will connect update API in next step.
        |--------------------------------------------------------------------------
        */

  const handleSubmit = async (event) => {
    event.preventDefault();

    /*
        |--------------------------------------------------------------------------
        | BASIC VALIDATION
        |--------------------------------------------------------------------------
        */

    if (!String(form.name || "").trim()) {
      return;
    }

    /*
        |--------------------------------------------------------------------------
        | UPDATE
        |--------------------------------------------------------------------------
        */

    const result = await dispatch(
      updateTenantProfile({
        name: form.name,

        mobile: form.mobile,

        email: form.email,
      }),
    );

    /*
        |--------------------------------------------------------------------------
        | REFRESH COMPLETE PROFILE
        |--------------------------------------------------------------------------
        |
        | This keeps useAuth/sidebar/profile data synchronized.
        |--------------------------------------------------------------------------
        */

    if (updateTenantProfile.fulfilled.match(result)) {
      await dispatch(fetchTenantProfile());
    }
  };

  /*
        |--------------------------------------------------------------------------
        | LOADING
        |--------------------------------------------------------------------------
        */

  if (loading && !user) {
    return <div className="settings-loading">Loading profile...</div>;
  }
  {
    updateSuccess && (
      <div className="settings-success">Profile updated successfully.</div>
    );
  }

  {
    updateError && (
      <div className="settings-error">
        {updateError?.message || "Unable to update profile."}
      </div>
    );
  }
  return (
    <form onSubmit={handleSubmit}>
      {/* ============================================================
                    HEADER
                ============================================================ */}

      <div className="settings-section-header">
        <div>
          <h2>Profile</h2>

          <p>Manage your personal account information.</p>
        </div>
      </div>

      {/* ============================================================
                    ERROR
                ============================================================ */}

      {error && (
        <div className="settings-error">
          {error?.message || "Unable to load profile."}
        </div>
      )}

      {/* ============================================================
                    PROFILE SUMMARY
                ============================================================ */}

      <div className="settings-profile-summary">
        <div className="settings-profile-avatar">
          {String(form.name || "U")
            .charAt(0)
            .toUpperCase()}
        </div>

        <div>
          <strong>{form.name || "Administrator"}</strong>

          <span>{role?.name || user?.userType || "User"}</span>
        </div>
      </div>

      {/* ============================================================
                    FORM
                ============================================================ */}

      <div className="settings-form-grid">
        <div className="settings-field">
          <label>Full Name</label>

          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Full name"
          />
        </div>

        <div className="settings-field">
          <label>Mobile Number</label>

          <input
            type="text"
            name="mobile"
            value={form.mobile}
            onChange={handleChange}
            placeholder="Mobile number"
          />
        </div>

        <div className="settings-field">
          <label>Email Address</label>

          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Email address"
          />
        </div>

        <div className="settings-field">
          <label>User Type</label>

          <input type="text" value={user?.userType || ""} disabled />
        </div>

        <div className="settings-field">
          <label>Role</label>

          <input type="text" value={role?.name || role?.code || ""} disabled />
        </div>

        <div className="settings-field">
          <label>Account Status</label>

          <input type="text" value={user?.status || ""} disabled />
        </div>
      </div>

      {/* ============================================================
                    ACTION
                ============================================================ */}

      <div className="settings-actions">
        <button
          type="submit"
          className="settings-save-button"
          disabled={updating}
        >
          {updating ? "Updating..." : "Update Profile"}
        </button>
      </div>
    </form>
  );
};

export default ProfileSettings;
